import { render, staticRenderFns } from "./mapold.vue?vue&type=template&id=5f6e2484"
import script from "./mapold.vue?vue&type=script&lang=js"
export * from "./mapold.vue?vue&type=script&lang=js"
import style0 from "./mapold.vue?vue&type=style&index=0&id=5f6e2484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports